/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Distinct filterable values observed in the range
 */
export type GetEventFacetsResult = {
  /**
   * Distinct event/span names in ascending order
   */
  names: Array<string>;
  /**
   * Distinct sources in ascending order
   */
  sources: Array<string>;
};

/** @internal */
export const GetEventFacetsResult$inboundSchema: z.ZodMiniType<
  GetEventFacetsResult,
  unknown
> = z.object({
  names: z.array(z.string()),
  sources: z.array(z.string()),
});

export function getEventFacetsResultFromJSON(
  jsonString: string,
): SafeParseResult<GetEventFacetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEventFacetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEventFacetsResult' from JSON`,
  );
}
